import React from 'react';
import { Button, Copy } from '@grubhubprod/gh-cookbook-react';
import { useAuth } from 'src/components/AuthProvider/AuthProvider';

export function SignOutButton(): JSX.Element {
  const { signOut } = useAuth();

  return (
    <Button
      variant="tertiary"
      onClick={signOut}
      className="removeButtonPadding autoButtonHeight"
    >
      <Copy variant="body" color="interactive">
        Sign out
      </Copy>
    </Button>
  );
}
